import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    Typography,
    Button
} from "../ui";

export default function PaymentDetailsDialog({ open, onClose, paymentDetails }) {

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Payment Details</DialogTitle>

            <DialogContent dividers>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    {Object.entries(paymentDetails).map(([rawKey, value], index) => {
                        const key = rawKey.trim();
                        const displayValue = value?.trim() || "-";

                        return (
                            <Box
                                key={index}
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: "170px 1fr",  // FIXED KEY WIDTH
                                    alignItems: "center",
                                    padding: "8px 0",
                                    borderBottom: "1px solid #eee",
                                    columnGap: 2,
                                }}
                            >
                                <Typography sx={{ fontWeight: 600, color: "black" }}>
                                    {key}
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#1976d2",
                                        textAlign: "right",
                                    }}
                                >
                                    {displayValue}
                                </Typography>
                            </Box>
                        );
                    })}
                </Box>
            </DialogContent>




            <DialogActions>
                <Button variant="contained" onClick={onClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
